import "@fontsource/montserrat"

// custom CSS styles
import "./src/style.scss"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

// Image lazyload
import 'lazysizes'

// VH Check
import vhCheck from 'vh-check'
vhCheck()
